import { MenuItem, TextField, Typography } from "@mui/material";
import React from "react";
import { FlexCenter, FlexRowSB } from "../../constant/CustomeStyle";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Tags from "./Tags";

const RightSection = () => {
  const itemLists = ["Yesterday", "Today", "Tomorrow"];

  const [itemOption, setItemOption] = React.useState(itemLists[0]);
  const handleOption = (e) => {
    setItemOption(e.target.value);
  };

  return (
    <div
      style={{
        width: 312,
        height: 600,
        background: "#FFF",
        marginTop: 10,
        marginRight: 20,
      }}
    >
      <TopHeading title={"Monday, January 02, 2022 2:35 PM"} />

      <div style={{ margin: 10 }}>
        <FlexRowSB style={{ marginBottom: 10 }}>
          <CustomeCheckBox label={"End - User Report"} />
          <CustomeCheckBox label={"Turbo Mode"} />
        </FlexRowSB>

        <FlexRowSB style={{ marginBottom: 10 }}>
          <DateBox />
          <DateBox />
        </FlexRowSB>

        <FlexRowSB>
          <CustomeButton text={"Refresh"} />
          <CustomeButton text={"Print"} />
          <CustomeButton text={"Save"} />
        </FlexRowSB>

        <InputBoxDropdown
          title={"Periods"}
          handleChange={handleOption}
          itemLists={itemLists}
          currentValue={itemOption}
        />

        <div>
          <Tags items={departments} title={"Depertments"} />
          <Tags items={users} title={"Users"} />
        </div>
      </div>
    </div>
  );
};

const CustomeCheckBox = ({ label }) => (
  <FormControlLabel
    control={
      <Checkbox
        sx={{
          color: "#FFF",
          "& .MuiSvgIcon-root": {
            // color: "#5D687A",
            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.188)",
          },
        }}
      />
    }
    label={
      <Typography
        sx={{
          color: "#000",
          fontSize: 12,
          fontFamily: "Poppins, sans-serif",
        }}
      >
        {label}
      </Typography>
    }
  />
);

const InputBoxDropdown = ({ title, handleChange, itemLists, currentValue }) => (
  <div>
    <div
      style={{
        textAlign: "left",
        marginTop: 15,
        marginBottom: 4,
        fontSize: 14,
        fontFamily: "Poppins, sans-serif",
        color: "#1D1D1D",
      }}
    >
      {title}
    </div>
    <TextField
      // id="outlined-select-currency"
      variant="standard"
      select
      value={currentValue}
      onChange={handleChange}
      sx={{
        width: "100%",
        cursor: "pointer",
      }}
      InputProps={{
        disableUnderline: true,
        style: {
          height: 30,
          background: "#FFF",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.188)",
          borderRadius: 2,
          textAlign: "left",
          fontSize: 14,
          paddingLeft: 10,
        },
      }}
    >
      {itemLists.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
  </div>
);

const DateBox = () => (
  <FlexCenter
    style={{
      width: 135.06,
      height: 31.1,
      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.188)",
    }}
  >
    <TextField
      variant="standard"
      id="date"
      type="date"
      defaultValue="2017-05-25"
      size="small"
      sx={{
        width: "90%",
        cursor: "pointer",
      }}
      InputProps={{
        disableUnderline: true,
        style: {
          color: "#333C4B",
          fontSize: 14,
          fontWeight: "400",
          fontFamily: `Poppins, sans-serif`,
        },
      }}
    />
  </FlexCenter>
);

const CustomeButton = ({ text }) => (
  <FlexCenter
    style={{
      width: 89,
      height: 31.1,
      color: "#333C4B",
      fontSize: 12,
      fontWeight: "500",
      fontFamily: `Poppins, sans-serif`,
      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.188)",
      cursor: "pointer",
    }}
  >
    {text}
  </FlexCenter>
);

const TopHeading = ({ title }) => (
  <FlexCenter
    style={{
      border: "1px solid #A5A5A5",
      height: 40,
      color: "#FFF",
      background: "#333C4B",
      fontSize: 16,
      fontWeight: "400",
      fontFamily: `Poppins, sans-serif`,
    }}
  >
    {title}
  </FlexCenter>
);

const departments = [
  { title: "Resturant" },
  { title: "Shop" },
  { title: "Bar" },
  { title: "Caffa" },
];

const users = [
  { title: "Sales" },
  { title: "Waiters" },
  { title: "A" },
  { title: "B" },
];

export default RightSection;
